import { render, staticRenderFns } from "./StatisticCards.vue?vue&type=template&id=69fa4f87&"
import script from "./StatisticCards.vue?vue&type=script&lang=js&"
export * from "./StatisticCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports